import { LegalPage } from "@/components/LegalPage";
import { SMS_SECTIONS } from "@/data/legal";

export default function SmsTerms() {
  return (
    <LegalPage
      testid="sms-terms-page"
      title="SMS Terms"
      intro="These terms describe our text messaging program and your consent under the TCPA."
      sections={SMS_SECTIONS}
    />
  );
}
